import { initContract } from '@ts-rest/core'
import z from 'zod'
import { CreatePartnerInputSchema, CreatePartnerOutputSchema } from './partners.schemas'
import { ResolvePromotionCodeResultSchema } from './schemas'
import { ErrorResponseSchema } from '../../shared'

const c = initContract()

export const partnersRoutes = c.router(
  {
    createPartnerAccount: {
      method: 'POST',
      path: '/workflows/create-partner',
      body: CreatePartnerInputSchema,
      responses: {
        200: CreatePartnerOutputSchema,
        400: ErrorResponseSchema,
        500: ErrorResponseSchema,
      },
    },
    resolvePromotionCode: {
      method: 'POST',
      path: '/workflows/resolve-promotion-code',
      body: z.object({
        code: z.string(),
        workflowId: z.string().optional(),
      }),
      responses: {
        200: ResolvePromotionCodeResultSchema,
      },
    },
  }
)
